// src/components/Home/Home.jsx
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import Hero from '../Hero/Hero';
import Services from '../Services/Services';
import About from '../About/About';
import WhyUs from '../WhyUs/WhyUs';
import Footer from '../Footer/Footer';

function Home() {
  const location = useLocation();

  // "Çalışma Alanlarımız" butonundan gelen scroll isteğini yakalıyoruz kanka
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('scrollTo') === 'services') {
      const element = document.getElementById('services-section');
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="page-wrapper">
        <Navbar/>
        <Hero/>
        
        {/* Çalışma alanları bileşenini id ile sarmaladık kanka */}
        <div id="services-section">
          <Services/>
        </div>

        <About/>
        <WhyUs/>
        <Footer/>
    </div>
  );
}

export default Home;